@if (collection$ | async; as collection) {
<div class="parts-catalog-navigation-menu-wrapper">
  <div class="name-block">
    <h1>{{collection.name}}</h1>

  </div>
  <div class="catalog-menu-items-grid">
    @for(child of collection?.children; track child.id){
    <a [routerLink]="['/',vehicleTypeService?.currentVehicleType,'shop','category', child.slug]" [queryParams]="{ modificationId: selectedModificationService?.selectedModificationId }">
      <span class="bubble"></span>
      <span class="text">{{child.name}}<span class="count">({{child.productsCount}})</span></span>
    </a>
    }
    @empty {

    }
  </div>
</div>
}
